import { Box, Button, Grid, MenuItem } from '@mui/material';
import { useApi, useMessage } from 'app/context';
import { useForm } from 'app/hooks';
import { Breadcrumb, DetailWrapperDiv, TextField, Typography } from 'app/shared';
import { buildErrorDetails, buildErrorMessage } from 'app/utils';
import { IMedicalCenterCreate } from 'generated/axios';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const MedicalCenterCreate = () => {
  const { medicalCenterApi } = useApi();
  const [loading, setLoading] = useState<boolean>(false);
  const { success, error } = useMessage();
  const navigate = useNavigate();

  const create = (form: IMedicalCenterCreate) => {
    setLoading(true);
    medicalCenterApi
      .createMedicalCenter(form)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        success({ message: t('medicalCenter.createSuccess') as string });
        navigate(-1);
      })
      .catch((err) => {
        error({ message: buildErrorMessage(err) });
        setErrors(buildErrorDetails(err));
      })
      .finally(() => setLoading(false));
  };

  const { setErrors, bindTextField, bindSelect, submit } = useForm<IMedicalCenterCreate>({
    onSubmit: create,
    requiredFields: ['name', 'language'],
    requiredValidationOptions: { errorMsg: t('info.mandatoryField'), validationTime: 'ON_SUBMIT' },
  });
  return (
    <>
      <Breadcrumb />
      <DetailWrapperDiv>
        <Typography detailTitle>{t('medicalCenter.new')}</Typography>
        <Grid container spacing={4}>
          <Grid size={6}>
            <TextField label={t('medicalCenter.name')} {...bindTextField({ field: 'name' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('medicalCenter.email')} {...bindTextField({ field: 'user_email' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('medicalCenter.vatNumber')} {...bindTextField({ field: 'vat_number' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('medicalCenter.address')} {...bindTextField({ field: 'address' })} />
          </Grid>
          <Grid size={6}>
            <TextField label={t('medicalCenter.phone')} {...bindTextField({ field: 'phone' })} />
          </Grid>
          <Grid size={2}>
            <TextField label={t('common.language')} {...bindSelect({ field: 'language' })}>
              <MenuItem key={'it'} value={'it'}>
                IT
              </MenuItem>
              <MenuItem key={'en'} value={'en'}>
                EN
              </MenuItem>
              <MenuItem key={'fr'} value={'fr'}>
                FR
              </MenuItem>
              <MenuItem key={'de'} value={'de'}>
                DE
              </MenuItem>
              <MenuItem key={'es'} value={'es'}>
                ES
              </MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <Box padding={4}>
          <Button variant="contained" loading={loading} onClick={submit}>
            {t('actions.submit')}
          </Button>
        </Box>
      </DetailWrapperDiv>
    </>
  );
};
